import styled, { css } from 'styled-components';
import _ from 'lodash';
import Button from 'components/Button';
import { colorVariables, otherVariables } from 'theme/variables';

export const SliderStyled = styled.div`
  width: 100%;
  position: relative;

  * {
    user-select: none;
  }
`;

export const Wrapper = styled.div`
  position: absolute;
  width: 100%;
  height: ${otherVariables.trackHeight};
  left: 0;
  top: calc(50% - 2px);
  outline: none;
  background-color: rgba(255, 255, 255, 0.2);
  transition: transform 0.1s;

  ${({ isMobile }) =>
    !isMobile &&
    css`
      ${TrackContent}:hover & {
        transform: scaleY(1.5);
      }
    `}

  ${({ isMobile }) =>
    isMobile &&
    css`
      height: ${otherVariables.trackMobileHeight};
    `};

  ${({ activeThumb }) =>
    activeThumb &&
    css`
      opacity: 1;
      transform: scale(1);
    `}
`;

export const TrackThumb = styled.div`
  position: absolute;
  width: 25px;
  height: 15px;
  right: 0;
  top: 50%;
  transform: translate(50%, -50%);
  z-index: 1;

  &:after {
    content: '';
    display: block;
    position: absolute;
    width: 14px;
    height: 14px;
    border-radius: 7px;
    background-color: ${({ theme }) => colorVariables[theme.main_default]};
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }
`;

export const Content = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ContentWrap = styled.div`
  position: relative;
  width: 100%;

  &:focus {
    outline: none;
  }

  ${(props) =>
    props.type === 'volume' &&
    css`
      visibility: hidden;
      opacity: 0;
      width: 0;
      padding: 0 0 5px;
      height: 40px;
      transition:
        width 200ms cubic-bezier(1, 0, 1, 0),
        opacity 175ms ease-in,
        visibility 175ms ease-in;
    `};

  ${({ type, isMobile }) =>
    type === 'volume' &&
    !isMobile &&
    css`
      ${SliderStyled}:hover & {
        visibility: visible;
        opacity: 1;
        width: 80px;
        transition: 135ms ease-out;
      }
    `};

  ${({ seeking }) =>
    seeking &&
    css`
      visibility: visible;
      opacity: 1;
      width: 80px;
      transition: 135ms ease-out;
    `};
`;

export const Track = styled.div`
  width: 100%;
  height: 100%;
`;

export const TrackContent = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  height: 16px;
  cursor: pointer;
  outline: none;
  touch-action: none;

  &:focus {
    outline: none;
  }

  ${({ type }) =>
    type === 'volume' &&
    css`
      padding: 0;
      height: 100%;
      width: 80px;
    `};

  ${({ isMobile }) =>
    isMobile &&
    css`
      padding: 10px 0;
    `};
`;

export const Buffered = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.3);
  transform: scaleX(0.8);
  transform-origin: 0 0;
  transition: transform 0.1s;
`;

export const AdTimeLabel = styled.div`
  position: absolute;
  width: 3px;
  height: 100%;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 2px;
  background-color: rgba(255, 255, 255, 0.3);

  ${({ point }) => css`
    left: ${point}%;
  `};
`;

export const SeekHover = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  background-color: rgba(255, 255, 255, 0.2);
  z-index: 2;
  transform: scaleX(0.6);
  transform-origin: 0 0;

  ${ContentWrap}:hover & {
    opacity: 1;
  }
`;

export const Connect = styled.div`
  position: absolute;
  left: 0;
  height: 100%;
  background-color: ${({ theme }) =>
    _.get(colorVariables, theme.main, colorVariables.blue_doger)};
  transition: width 0.1s;

  ${({ isMobile, theme }) =>
    isMobile &&
    css`
      background-color: ${_.get(
        colorVariables,
        theme.main_default,
        colorVariables.blue_doger
      )};
    `};
`;

export const Thumb = styled.div`
  pointer-events: none;
  position: absolute;
  width: 12px;
  height: 12px;
  left: -6px;
  top: 4px;
  z-index: 4;
  transform: translateX(100px);
`;

export const Handler = styled.div`
  transition: transform 0.1s;
  border-radius: 100%;
  width: 100%;
  height: 100%;
  background-color: red;
  opacity: 0;
  transform: scale(0.4);

  ${({ activeThumb }) =>
    activeThumb &&
    css`
      opacity: 1;
      transform: scale(1);
    `};
`;

export const VolumeButton = styled.div`
  position: relative;
`;

export const StyledButton = styled(Button)`
  && {
    padding: 6px 35px 13px;

    ${({ isMobile }) =>
      isMobile &&
      css`
        padding: 0px 10px 0px;
      `};
  }
`;
